import { render, staticRenderFns } from "./gridWork.vue?vue&type=template&id=0b567190&"
import script from "./gridWork.vue?vue&type=script&lang=js&"
export * from "./gridWork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports